
import { defineComponent } from "vue";

import common from "../styles/common.module.less";
import { Icon } from "./icons";

export default defineComponent({
  name: "XiyouEmptyState",
  props: {
    title: { type: String, default: "暂无内容" },
    desc: { type: String, default: "" },
    icon: { type: String, default: "inbox" },
  },
  setup(props, { slots }) {
    return () => (
      <div class={common.empty}>
        <span class={common.emptyIcon}>
          <Icon name={props.icon} />
        </span>
        <div class={common.emptyTitle}>{props.title}</div>
        {props.desc ? <div class={common.emptyDesc}>{props.desc}</div> : null}
        {slots.default ? (
          <div style={{ marginTop: "2rem" }}>{slots.default()}</div>
        ) : null}
      </div>
    );
  },
});
